import React, { useContext } from 'react';
import { Context } from 'components/Store';
import { FormikSelect } from 'components/UiKit/FormikFields';
import { tillageSystemFields } from '../DataSets';

const TillageSystem = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <FormikSelect
      id="tillage"
      name="tillage"
      placeholder="Select tillage system"
      items={tillageSystemFields}
      label="Tillage System"
      disabled={!isEnableInfoTabEdit}
    />
  );
};

export default TillageSystem;
